import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const softmaxComponent: ComponentDef = {
  id: 'softmax',
  name: 'Softmax',
  description: 'Softmax over logits to produce a probability distribution.',
  category: 'function',
  params: [
    { name: 'seq_len', label: 'Sequence length', type: 'number', default: 128, min: 1, max: 8192, step: 1 },
    { name: 'num_classes', label: 'Classes', type: 'number', default: 1000, min: 2, max: 100000, step: 1 },
    { name: 'dim', label: 'Softmax dim', type: 'select', default: '-1', options: [{ label: 'Last', value: '-1' }, { label: '0', value: '0' }, { label: '1', value: '1' }] },
    { name: 'variant', label: 'Variant', type: 'select', default: 'safe', options: [{ label: 'Naive', value: 'naive' }, { label: 'Safe (subtract max)', value: 'safe' }, { label: 'Online (single-pass)', value: 'online' }] }
  ],
  buildGraph: (params) => {
    const seq_len = Number(params.seq_len);
    const num_classes = Number(params.num_classes);
    const variant = params.variant;
    const g = new GraphBuilder();
    g.input('logits', [seq_len, num_classes]);

    if (variant === 'naive') {
      g.activation('exp', 'logits', 'exp');
      g.scale('sum', 'exp', 'sum');
      g.scale('probs', 'sum', 'div');
    } else if (variant === 'online') {
      g.scale('running_max', 'logits', 'running max');
      g.scale('running_sum', 'running_max', 'running sum');
      g.scale('probs', 'running_sum', 'normalize');
    } else {
      g.scale('max', 'logits', 'max');
      g.add('shifted', 'logits', 'max');
      g.activation('exp', 'shifted', 'exp');
      g.scale('sum', 'exp', 'sum');
      g.scale('probs', 'sum', 'div');
    }

    g.output('out', 'probs');
    return g.build();
  }
};
